/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreatePhotonBeamQualityDto } from './CreatePhotonBeamQualityDto';
import {
    CreatePhotonBeamQualityDtoFromJSON,
    CreatePhotonBeamQualityDtoFromJSONTyped,
    CreatePhotonBeamQualityDtoToJSON,
} from './CreatePhotonBeamQualityDto';

/**
 * 
 * @export
 * @interface CreatePhotonBeamQualitiesDto
 */
export interface CreatePhotonBeamQualitiesDto {
    /**
     * 
     * @type {Array<CreatePhotonBeamQualityDto>}
     * @memberof CreatePhotonBeamQualitiesDto
     */
    values?: Array<CreatePhotonBeamQualityDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePhotonBeamQualitiesDto
     */
    visible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePhotonBeamQualitiesDto
     */
    $type?: CreatePhotonBeamQualitiesDtoTypeEnum;
}


/**
 * @export
 */
export const CreatePhotonBeamQualitiesDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoTreatmentMachinesConfigurationCreatePhotonBeamQualitiesDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreatePhotonBeamQualitiesDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreatePhotonBeamQualitiesDtoTypeEnum = typeof CreatePhotonBeamQualitiesDtoTypeEnum[keyof typeof CreatePhotonBeamQualitiesDtoTypeEnum];


/**
 * Check if a given object implements the CreatePhotonBeamQualitiesDto interface.
 */
export function instanceOfCreatePhotonBeamQualitiesDto(value?: unknown): value is CreatePhotonBeamQualitiesDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreatePhotonBeamQualitiesDtoTypeEnum)[0];
}

export function CreatePhotonBeamQualitiesDtoFromJSON(json: any): CreatePhotonBeamQualitiesDto {
    return CreatePhotonBeamQualitiesDtoFromJSONTyped(json, false);
}

export function CreatePhotonBeamQualitiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePhotonBeamQualitiesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'values': !exists(json, 'values') ? undefined : (json['values'] === null ? null : (json['values'] as Array<any>).map(CreatePhotonBeamQualityDtoFromJSON)),
        'visible': !exists(json, 'visible') ? undefined : json['visible'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreatePhotonBeamQualitiesDtoToJSON(value?: CreatePhotonBeamQualitiesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'values': value.values === undefined ? undefined : (value.values === null ? null : (value.values as Array<any>).map(CreatePhotonBeamQualityDtoToJSON)),
        'visible': value.visible,
        '$type': value.$type,
    });
}

